import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {Modal, ModalFormFooter, ManagerTip} from '@/components'
import {CardFreezeModalProps} from './props'

export const CardFreezeModal: React.FC<CardFreezeModalProps> = observer((
    {open, onCancel}
) => {
    const { t } = useTranslation()
    return (
        <Modal
            open={open}
            title={t('CardFreezeModal.title')}
            onCancel={onCancel}
            footer={<ModalFormFooter
                formId={'set-paypal-settings'}
                onCancel={onCancel}
                cancelText={t('CardFreezeModal.cancel')}
                okText={t('CardFreezeModal.freezeCard')}
            />}
        >
            <ManagerTip text={t('CardFreezeModal.freezeYourCardTemporarily')}/>
        </Modal>
    )
})
